import React from 'react'
import '../style/page_06.scss'
import AwesomeSwpier from 'react-awesome-swiper'
// import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.scss';
const config = {
  watchSlidesProgress: true,
  slidesPerView: 'auto',
  centeredSlides: true,
  loop: true,
  loopedSlides: 5,
  autoplay: true,
  coverflowEffect: {
    rotate: 0,
    stretch: 81,
    depth: 154,
    modifier: 1,
    slideShadows: false
  },
  pagination: {
    el: '.swiper-pagination',
    bulletElement: 'li',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    progress: function (progress) {
      for (let i = 0; i < this.slides.length; i++) {
        var slide = this.slides.eq(i);
        var slideProgress = this.slides[i].progress;
        let modify = 1;
        if (Math.abs(slideProgress) > 1) {
          modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
        }
        let translate = slideProgress * modify * 112 + 'px';
        let scale = 1 - Math.abs(slideProgress) /6;
        let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
        slide.css('zIndex', zIndex);
        slide.css('opacity', 1);
        if (Math.abs(slideProgress) > 3) {
          slide.css('opacity', 0);
        }
      }
    },
    setTransition: function (transition) {
      for (var i = 0; i < this.slides.length; i++) {
        var slide = this.slides.eq(i)
        slide.transition(transition);
      }

    }
  }
};
class Page06 extends React.Component {
  constructor(props) {
    super();
    this.state = {
      tabIndex: 1,
      currentSwiperIndex: 0
    }
  }
  swiperRef = null;

  // componentDidMount() {
  //   var _this = this;
  //   this.swiperRef.swiper.on('slideChange', function() {
  //     console.log(this.realIndex);
  //      _this.setState({ currentSwiperIndex: this.realIndex }) 
  //   })
  // }
  scrollPage = () => {
    window.$('html,body').animate({
      scrollTop:0
    },1000);
  }

  switchTab = (e) => {
    const index = Number(e.currentTarget.dataset.index);
    console.log(index)
    if (index === this.state.tabIndex) {
      return;
    }
    this.setState({ tabIndex: index })
  }

  render() {
    return (
      <div className="page page_06" >
        <div className="title"></div>
        {/* <div className="tab-name-container">
          <div data-index="1" className={`tab-name ${this.state.tabIndex === 1 ? 'active' : ''}`} onClick={this.switchTab}><div className="inner"></div></div>
          <div data-index="2" className={`tab-name ${this.state.tabIndex === 2 ? 'active' : ''}`} onClick={this.switchTab}><div className="inner"></div></div>
        </div> */}
        {/* <div className="line">
          <div className="underline" style={{ 'marginLeft': this.state.tabIndex === 1 ? '-230px' : '36px' }}></div>
        </div> */}
        <div className="tab-content">
          <div style={{ 'display': this.state.tabIndex === 1 ? 'block' : 'none' }}>
            <AwesomeSwpier ref={ref => (this.swiperRef = ref)} config={config}>
              <div className="swiper-wrapper">
                <div className="swiper-slide"><img src='https://static.web.sdo.com/xuezu/pic/20200820_Kill/pc_2nd/swiper-slide-1.jpg' alt="" /></div>
                <div className="swiper-slide"><img src='https://static.web.sdo.com/xuezu/pic/20200820_Kill/pc_2nd/swiper-slide-2.jpg' alt="" /></div>
                <div className="swiper-slide"><img src='https://static.web.sdo.com/xuezu/pic/20200820_Kill/pc_2nd/swiper-slide-3.jpg' alt="" /></div>
                <div className="swiper-slide"><img src='https://static.web.sdo.com/xuezu/pic/20200820_Kill/pc_2nd/swiper-slide-4.jpg' alt="" /></div>
                <div className="swiper-slide"><img src='https://static.web.sdo.com/xuezu/pic/20200820_Kill/pc_2nd/swiper-slide-5.jpg' alt="" /></div>
                <div className="swiper-slide"><img src='https://static.web.sdo.com/xuezu/pic/20200820_Kill/pc_2nd/swiper-slide-6.jpg' alt="" /></div>
              </div>
              <div className="swiper-pagination"></div>
            </AwesomeSwpier>
            <div className="swiper-button-prev"></div>
            <div className="swiper-button-next"></div>
          </div>
          <div style={{ 'display': this.state.tabIndex === 2 ? 'block' : 'none' }}></div>
        </div>
        <div className="top" onClick={this.scrollPage}></div>
      </div>
    )
  }

}

export default Page06;
